import { MpuDimensions } from "./MpuDimensions";
import { mpuSize } from "@rezonence/freewall-ruler";

export const defaultMpuDimensions: MpuDimensions = {
    width: mpuSize[0],
    height: mpuSize[1]
};
